import { render } from "./LoginPopup.vue?vue&type=template&id=4387591e&scoped=true"
import script from "./LoginPopup.vue?vue&type=script&lang=js"
export * from "./LoginPopup.vue?vue&type=script&lang=js"

import "./LoginPopup.vue?vue&type=style&index=0&id=4387591e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4387591e"]])

export default __exports__